import { render, staticRenderFns } from "./ScreenSaver.vue?vue&type=template&id=d9c95106&"
import script from "./ScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./ScreenSaver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports